import fontawesome from '@fortawesome/fontawesome';

import {
  faSortUp,
  faSortDown,
  faUtensils,
  faListAlt,
  faExternalLinkAlt,
  faInfoCircle,
  faFilter,
  faAngleDown,
  faTimesCircle,
  faLock,
  faLockOpen,
  faShareAlt,
  faSpinner,
  faEllipsisV,
  faPencilAlt,
  faTrashAlt,
  faCheck,
  faTimes,
  faCamera,
  faCloudUploadAlt,
  faUndoAlt,
  faRedoAlt,
  faFolderOpen,
  faCaretDown,
} from '@fortawesome/fontawesome-free-solid';

import {
  faYoutube,
} from '@fortawesome/fontawesome-free-brands';

function config() {
  fontawesome.library.add(
    faSortUp,
    faSortDown,
    faUtensils,
    faListAlt,
    faExternalLinkAlt,
    faInfoCircle,
    faFilter,
    faAngleDown,
    faYoutube,
    faTimesCircle,
    faLock,
    faLockOpen,
    faShareAlt,
    faSpinner,
    faEllipsisV,
    faPencilAlt,
    faTrashAlt,
    faCheck,
    faTimes,
    faCamera,
    faCloudUploadAlt,
    faUndoAlt,
    faRedoAlt,
    faFolderOpen,
    faCaretDown,
  );
}

export default config;



// WEBPACK FOOTER //
// ./src/fa-config.js